import React from 'react';

import User from 'components/Icons/User';

import { useLoginContext } from '../context';
import * as Styled from './styled';

export type ComponentProps = {};

/**
 * This component renders when user is logged out
 */
const LoggedOut: React.FC<ComponentProps> = () => {
  const { loginUrl, linkTarget = '_self', authManager, setIsLoggedIn } = useLoginContext();

  /**
   * event handler when the login button is clicked
   */
  const onLogin = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    await authManager.signInUser();
    setIsLoggedIn(true);
  };
  return (
    <Styled.Wrapper href={loginUrl} target={linkTarget} onClick={onLogin}>
      <Styled.Text>Log in</Styled.Text>
      <Styled.UserIconWrapper>
        <User />
      </Styled.UserIconWrapper>
    </Styled.Wrapper>
  );
};

export default LoggedOut;
